import { render, staticRenderFns } from "./HintStatement.vue?vue&type=template&id=52deb9c8&"
import script from "./HintStatement.vue?vue&type=script&lang=js&"
export * from "./HintStatement.vue?vue&type=script&lang=js&"
import style0 from "./HintStatement.vue?vue&type=style&index=0&id=52deb9c8&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports